

export default function formatPercent(value: number) {
  return Math.round(value * 100).toLocaleString("DE");
}

export function formatNumber(value: number) {
  if (value > 50) {
    return Math.round(value).toLocaleString("DE")
  }
  else {
    return (Math.round(value * 10) / 10).toLocaleString("DE")
  }
}